const items = [
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 2, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 3, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 4, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 5, up: false, image: require('./assets/cards/one-yellow-light.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/one-yellow-light.svg'), correct: true },
      { id: 2, image: require('./assets/cards/one-red-fire.svg'), correct: false },
      { id: 3, image: require('./assets/cards/one-green-snow.svg'), correct: false },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/one-yellow-light.svg'), correct: false },
      { id: 2, image: require('./assets/cards/one-red-fire.svg'), correct: true },
      { id: 3, image: require('./assets/cards/one-green-snow.svg'), correct: false },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-green-snow.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/one-yellow-light.svg'), correct: false },
      { id: 2, image: require('./assets/cards/one-red-fire.svg'), correct: false },
      { id: 3, image: require('./assets/cards/one-green-snow.svg'), correct: true },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-snow.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/one-green-light.svg'), correct: false },
      { id: 2, image: require('./assets/cards/one-yellow-fire.svg'), correct: false },
      { id: 3, image: require('./assets/cards/one-red-snow.svg'), correct: true },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-yellow-snow.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-snow.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-green-fire.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/one-green-snow.svg'), correct: true },
      { id: 2, image: require('./assets/cards/one-red-snow.svg'), correct: false },
      { id: 3, image: require('./assets/cards/one-yellow-snow.svg'), correct: false },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/three-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-yellow-light.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/three-yellow-light.svg'), correct: false },
      { id: 2, image: require('./assets/cards/one-red-fire.svg'), correct: true },
      { id: 3, image: require('./assets/cards/two-green-snow.svg'), correct: false },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-yellow-snow.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-yellow-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/three-red-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-yellow-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-yellow-light.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/three-red-light.svg'), correct: true },
      { id: 2, image: require('./assets/cards/three-yellow-light.svg'), correct: false },
      { id: 3, image: require('./assets/cards/one-red-light.svg'), correct: false },
    ],
  },
  {
    old: [
      { id: 1, up: false, image: require('./assets/cards/one-red-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-yellow-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/one-green-light.svg') },
      { id: 1, up: false, image: require('./assets/cards/two-green-fire.svg') },
      { id: 1, up: false, image: require('./assets/cards/three-green-fire.svg') },
    ],
    new: [
      { id: 1, image: require('./assets/cards/one-yellow-light.svg'), correct: false },
      { id: 2, image: require('./assets/cards/three-red-light.svg'), correct: false },
      { id: 3, image: require('./assets/cards/two-green-light.svg'), correct: true },
    ],
  },
]

export default items.map((item) => {
  item.new = item.new.map((item2, index) => ({ ...item2, id: index + 1 }))
  item.old = item.old.map((item2, index) => ({ ...item2, id: index + 1 }))

  return item
})
